// extracted by mini-css-extract-plugin
export default {"zoomModal":"_0-z","image":"a1-z","button":"b1-z","isOverlayShown":"c1-z"};